import { render, staticRenderFns } from "./CourseList.vue?vue&type=template&id=9a5231fe&scoped=true&lang=true&"
import script from "./CourseList.vue?vue&type=script&lang=js&"
export * from "./CourseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5231fe",
  null
  
)

export default component.exports